import React from "react"
import {SbDialog} from "../../commons/sb-dialog";
import {t, Trans} from "@lingui/macro";
import {Typography} from "@mui/material";

interface SkipActionDialogProps {
    onClose: () => void
    skip: () => void
}

interface SkipActionDialogState {

}

export class SkipActionDialog extends React.Component<SkipActionDialogProps, SkipActionDialogState>
{

    render() {
        return (
            <SbDialog onClose={this.props.onClose}
                      width={"md"}
                      titleText={t({id: "workflow.workflow-action.skip.title", message: "Salta azione"})}
                      cancelButton
                      confirmButton
                      onConfirm={this.props.skip}
            >
                <Typography>
                    <Trans id={"workflow.workflow-action.skip"}>
                        Sei sicuro di voler saltare l'azione? L'operazione è irreversibile.
                    </Trans>
                </Typography>
            </SbDialog>
        )
    }
}
